module.exports = __webpack_public_path__ + "static/media/honda-small-street-selected.4d94bdbb.svg";